import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { StateService } from 'src/app/core';
import { WindowRefService } from 'src/app/core/services/window-ref.service';
import { environment } from 'src/environments/environment';
import { LuStickyFiltersService } from '../../../../angie-shared/modules/sticky-filters/sticky-filters.service';
import { Auth } from '../../models/auth';
import { IAuthData } from '../../models/auth.model';
import { AuthConfigService } from '../../service/auth-config.service';
import { AuthService } from '../../service/auth.service';

@Component({
	templateUrl: './sign-in.component.html',
	styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent extends Auth implements OnInit, AfterViewInit {
	inProgress$ = new BehaviorSubject<boolean>(false);

	cdnPath: string = environment.cdnBase;
	alreadyPrevented = false;
	data: IAuthData;
	nextPage: string; // Flag used to redirect after sign-in
	authCode: string;

	constructor(
		authService: AuthService,
		toastrService: ToastrService,
		translateService: TranslateService,
		private windowRefService: WindowRefService,
		private authConfigService: AuthConfigService,
		private http: HttpClient,
		private activatedRoute: ActivatedRoute,
		private stateService: StateService,
		private stickyFilterService: LuStickyFiltersService
	) {
		super(authService, toastrService, translateService);
	}
	ngOnInit(): void {
		// We are clearing all sticky filters in case user didn't manually logged out and session is expired
		this.stickyFilterService.clearAllFilters();
		this.authConfigService.setMetaTitle('lup.login.login_label');
		this.nextPage = this.activatedRoute.snapshot.queryParamMap.get('next') || '';
		this.data = this.authService.authData;
		this.authForm.fields = [
			this.authConfigService.getEmailOrUsername(this.data.login_with_usernames),
			this.authConfigService.getPassword()
		];
		this.authCode = this.activatedRoute.snapshot.queryParamMap.get('auth_code') || '';
		this.layoutConfig = {
			custom_sign_into_text: this.data.custom_sign_into_text,
			portalName: this.data.title,
			login_welcome_message: this.data.login_welcome_message,
			logo_alt: this.data.logo_alt,
			allow_user_to_self_register: this.data.allow_user_to_self_register
		};
	}

	ngAfterViewInit(): void {
		super.ngAfterViewInit();
	}

	signIn(): void {
		if (this.authForm.formGroup.invalid) {
			return;
		}
		if (this.inProgress$.getValue() === true) {
			return;
		}
		this.inProgress$.next(true);
		this.authService
			.signIn({ ...this.authForm.model, next: this.nextPage, authCode: this.authCode })
			.pipe(finalize(() => this.inProgress$.next(false)))
			.subscribe(
				({ data }) => {
					if (!data.next) {
						this.windowRefService.getWindow().location.href = '/';
						return;
					}
					/**
					 * data.next will redirect user to ex. complete_my_profile, BE will decide where to redirect user.
					 */
					this.windowRefService.getWindow().location.href = data.next;
				},
				({ error }) => {
					this.toastrService.error(this.translateService.instant(error?.error?.message));
				}
			);
	}
	oauth(id: string): void {
		this.http.post('/external_auth/', { data: { id, return_url_page: null } }).subscribe(() => {
			let body = document.getElementsByTagName('body')[0];
			let tmpForm = document.createElement('form');
			tmpForm.action = `/auth/${id}`;
			tmpForm.method = 'POST';
			tmpForm.name = 'tmpForm';
			let input = document.createElement('input');
			input.name = 'authenticity_token';
			input.type = 'text';
			input.value = this.stateService.xsrfToken;
			tmpForm.appendChild(input);
			body.append(tmpForm);
			tmpForm.submit();
			tmpForm.remove();
		});
	}

	showPasswordChangeDisabled() {
		this.toastrService.error(this.translateService.instant('lup.login.reset_password_disabled'));
	}
}
